// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var StrikesColoringMethod;
(function (StrikesColoringMethod) {
    StrikesColoringMethod[StrikesColoringMethod["Classic"] = 0] = "Classic";
    StrikesColoringMethod[StrikesColoringMethod["HistoricalVolatility"] = 1] = "HistoricalVolatility";
})(StrikesColoringMethod || (StrikesColoringMethod = {}));
export function getStrikesColoringMethodKey(value) {
    switch (value) {
        case StrikesColoringMethod.Classic:
            return 'property.ColoringMethod.Classic';
        case StrikesColoringMethod.HistoricalVolatility:
            return 'property.ColoringMethod.HistoricalVolatility';
        default:
            return '';
    }
}
